import styled, { keyframes } from "styled-components";

const BADGE_CONFIG = {
    blue: {
        bg: "#1DA1F2",
        glow: "rgba(29, 161, 242, 0.35)",
        label: "Verified Fellow",
        tooltip: "Verified by Fellora",
    },
    gold: {
        bg: "linear-gradient(135deg, #c9a063, #e8c47d)",
        glow: "rgba(201, 160, 99, 0.4)",
        label: "Verified Organization",
        tooltip: "Verified Organization",
    },
    purple: {
        bg: "linear-gradient(135deg, #7c3aed, #a855f7)",
        glow: "rgba(124, 58, 237, 0.35)",
        label: "Community Founder",
        tooltip: "Community Founder",
    },
};

const SIZE = { sm: 16, md: 19, lg: 24 };
const ICON_SIZE = { sm: 10, md: 12, lg: 15 };

const CheckIcon = ({ size }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export const VerificationBadge = ({ type = "blue", size = "sm", className }) => {
    const cfg = BADGE_CONFIG[type] || BADGE_CONFIG.blue;
    const dim = SIZE[size] || SIZE.sm;
    const iconDim = ICON_SIZE[size] || ICON_SIZE.sm;

    return (
        <BadgeWrap
            className={className}
            $dim={dim}
            $bg={cfg.bg}
            $glow={cfg.glow}
            role="img"
            aria-label={cfg.label}
            data-tooltip={cfg.tooltip}
        >
            <CheckIcon size={iconDim} />
            <Tooltip>{cfg.tooltip}</Tooltip>
        </BadgeWrap>
    );
};

const popIn = keyframes`
    0%   { transform: scale(0.6); opacity: 0; }
    70%  { transform: scale(1.08); }
    100% { transform: scale(1); opacity: 1; }
`;

const BadgeWrap = styled.span`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${(p) => p.$dim}px;
    height: ${(p) => p.$dim}px;
    border-radius: 50%;
    background: ${(p) => p.$bg};
    margin-left: 4px;
    vertical-align: middle;
    flex-shrink: 0;
    cursor: pointer;
    animation: ${popIn} 0.3s ease;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    box-shadow: 0 0 0 1.5px rgba(255, 255, 255, 0.9);

    &:hover {
        transform: scale(1.18);
        box-shadow: 0 0 0 2px white, 0 0 0 4px ${(p) => p.$glow};
    }

    &:hover > span {
        opacity: 1;
        transform: translateX(-50%) translateY(0px);
        pointer-events: auto;
    }

    @media (prefers-color-scheme: dark) {
        box-shadow: 0 0 0 1.5px rgba(0, 0, 0, 0.5);
    }
`;

const Tooltip = styled.span`
    position: absolute;
    bottom: calc(100% + 7px);
    left: 50%;
    transform: translateX(-50%) translateY(4px);
    background: #0a1428;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    padding: 5px 10px;
    border-radius: 6px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease, transform 0.15s ease;
    z-index: 9999;
    letter-spacing: 0.3px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-top-color: #0a1428;
    }
`;

export default VerificationBadge;
